import { MaterialIcon } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import React from 'react'

interface TerminalIconRendererProps {
  value?: string
}

/**
 * Renders a GPS pin icon with "Terminal" tooltip for terminal cells
 */
export function TerminalIconRenderer({ value }: TerminalIconRendererProps): JSX.Element {
  return (
    <Tooltip title='Terminal'>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <MaterialIcon size={16} icon='location_on' style={{ color: 'var(--theme-color-1)' }} />
      </div>
    </Tooltip>
  )
}
